import { EventUtil } from '@as-react/common-utils';
import { useEffect } from 'react';
export const useEventListener = (event, handler) => {
    useEffect(() => {
        EventUtil.listen(event, handler);
        return () => {
            EventUtil.remove(event, handler);
        };
    }, [event, handler]);
};
